import {
    takeEvery,
    all,
    put,
    call
} from 'redux-saga/effects';
import * as staticDataGeneralApi from '../../api/staticDataGeneralApi';
import * as actions from './actions';

export function* initialise(api) {
    try {
        yield put(actions.setLoading());
        const monitoringCsas = yield call(api.getCsas);
        yield put(actions.setRows(monitoringCsas));
    } catch (error) {
        yield put(actions.fetchMonitorRowsFailed(error.message));
    }
}

export function* addToAcadiaSoft(api, action) {
    try {
        yield put(actions.setLoading());
        yield call(api.editCsaInAcadiasoft, { csaId: action.csa, id: action.id, isEnabledToSend: action.checked });
        const monitoringCsas = yield call(api.getCsas);
        yield put(actions.setRows(monitoringCsas));
        yield put(actions.addToAcadiaSoftSuccess());
    } catch (error) {
        yield put(actions.addToAcadiaSoftError(error.message));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.INITIALISE,
            initialise, staticDataGeneralApi),
        takeEvery(actions.ADD_CSA_TO_ACADIA_SOFT,
            addToAcadiaSoft, staticDataGeneralApi)
    ]);
}
